import styles from "./styles.module.scss";

export const RootDesc = (props) => {
  const {children} = props;

  return <div className={styles.rootDesc}>{children}</div>;
};
